export const encryptOptions = [
  { label: 'Base64', value: 'Base64' },
  { label: 'MD5', value: 'MD5' }
]

export const fundsOptions = [
  { label: '月消费', value: 1 },
  { label: '月收支', value: 2 }
]

export const fundCategoryOptions1 = [
  { label: '餐饮食物', value: 1 },
  { label: '服饰美容', value: 2 },
  { label: '交通出行', value: 3 },
  { label: '通讯网络', value: 4 },
  { label: '医疗保健', value: 5 },
  { label: '住房物业', value: 6 },
  { label: '图书教育', value: 7 },
  { label: '娱乐聚餐', value: 8 },
  { label: '理财亏损', value: 9 },
]

export const fundCategoryOptions2 = [
  { label: '工资', value: 101 },
  { label: '理财', value: 102 },
  { label: '项目', value: 103 }
]

export const fundTypeOptions = [
  { label: '支出', value: 1 },
  { label: '收入', value: 2 }
]

export const fundStatusOptions = [
  { label: '正常', value: 1 },
  { label: '删除', value: 2 }
]

export const filterCategoryArray = [
  { text: '餐饮食物', value: 1 },
  { text: '服饰美容', value: 2 },
  { text: '交通出行', value: 3 },
  { text: '通讯网络', value: 4 },
  { text: '医疗保健', value: 5 },
  { text: '住房物业', value: 6 },
  { text: '图书教育', value: 7 },
  { text: '娱乐聚餐', value: 8 },
  { text: '理财亏损', value: 9 },
  { text: '工资', value: 101 },
  { text: '理财', value: 102 },
  { text: '项目', value: 103 },
]

export const filterTypeArray = [
  { text: '支出', value: 1 },
  { text: '收入', value: 2 },
]
